"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * JNext Reward API for client FE
 * Reward API
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 * Contact: cons.pompili@jakala.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardElementTypeEnum = void 0;
/**
 * ### Reward element type:  * `ITEM` - If the reward element is a physical item  * `WALLET` - If the reward element consists in point on a wallet  * `VOUCHER` - If the reward element is a voucher  * `SERVICE` - If the order item is a service
 * @export
 * @enum {string}
 */
var RewardElementTypeEnum;
(function (RewardElementTypeEnum) {
    RewardElementTypeEnum["Item"] = "ITEM";
    RewardElementTypeEnum["Voucher"] = "VOUCHER";
    RewardElementTypeEnum["Wallet"] = "WALLET";
    RewardElementTypeEnum["Service"] = "SERVICE";
})(RewardElementTypeEnum = exports.RewardElementTypeEnum || (exports.RewardElementTypeEnum = {}));
